(function () {
  "use strict";

  AddNewUserToCourseCtrl.$inject = ['$scope', '$location', 'resolveData', 'refreshSession'];
  angular
    .module('trainerWebApp.controllers')
    .controller('AddNewUserToCourseCtrl', AddNewUserToCourseCtrl);

  function AddNewUserToCourseCtrl($scope, $location, resolveData, refreshSession) {

    $scope.resolvedData = resolveData;

    refreshSession.refresh();

    var queryParams = $location.search();

    $scope.montara = queryParams.course;
  }

})();
